import { Arrows } from '@ad-lucy/components/nav/NavigationArrow/types';
import {
  CREATIVE_TYPE,
  type CreativesConfig,
  defaultCreativesConfig,
} from '@ad-lucy/config/creatives';
import type { bdComponentNames } from './componentNames';

type CreativesConfigComponentKeys = (typeof bdComponentNames)[number];

export const bdConfig: CreativesConfig<CreativesConfigComponentKeys> = {
  ...defaultCreativesConfig,
  id: CREATIVE_TYPE.BD,
  name: 'Branded Display',
  hasClickTrackerPreventation: true,
  settings: {
    ...defaultCreativesConfig.settings,
    autoplay: false,
  },
  navigation: {
    ...defaultCreativesConfig.navigation,
    defaults: {
      ...defaultCreativesConfig.navigation.defaults,
    },
    arrows: Arrows.NONE,
  },
  breakpoints: {
    ...defaultCreativesConfig.breakpoints,
    sitebar: '(min-width: 450px)',
    hpa: '(max-width: 449px) and (min-height: 850px)',
    mobile: '(max-width: 449px) and (max-height: 849px)',
  },
  ambilight: defaultCreativesConfig.ambilight,
  components: {
    category: {
      ...defaultCreativesConfig.components.category,
    },
    closeAd: {
      ...defaultCreativesConfig.components.closeAd,
      defaults: {
        ...defaultCreativesConfig.components.closeAd.defaults,
        centered: true,
      },
    },
    copyright: {
      ...defaultCreativesConfig.components.copyright,
    },
    countdown: {
      ...defaultCreativesConfig.components.countdown,
    },
    custom: {
      ...defaultCreativesConfig.components.custom,
    },
    footerLogo: {
      ...defaultCreativesConfig.components.footerLogo,
    },
    headerLogo: {
      ...defaultCreativesConfig.components.headerLogo,
    },
    html: {
      ...defaultCreativesConfig.components.html,
    },
    iframe: {
      ...defaultCreativesConfig.components.iframe,
    },
    image: {
      ...defaultCreativesConfig.components.image,
    },
    imageMap: {
      ...defaultCreativesConfig.components.imageMap,
    },
    imageMapArea: {
      ...defaultCreativesConfig.components.imageMapArea,
    },
    spotlights: {
      ...defaultCreativesConfig.components.spotlights,
    },
    spotlightsArea: {
      ...defaultCreativesConfig.components.spotlightsArea,
    },
    infoModal: {
      ...defaultCreativesConfig.components.infoModal,
    },
    link: {
      ...defaultCreativesConfig.components.link,
    },
    modal: {
      ...defaultCreativesConfig.components.modal,
      settings: {
        maxWidth: 'calc(100vh * (2 / 3) - 30px)',
      },
    },
    pricePatch: {
      ...defaultCreativesConfig.components.pricePatch,
    },
    search: {
      ...defaultCreativesConfig.components.search,
    },
    slider: {
      ...defaultCreativesConfig.components.slider,
    },
    sliderContainer: {
      ...defaultCreativesConfig.components.sliderContainer,
    },
    socialFlyoutBar: {
      ...defaultCreativesConfig.components.socialFlyoutBar,
    },
    socialMediaBar: {
      ...defaultCreativesConfig.components.socialMediaBar,
    },
    socialmedia: {
      ...defaultCreativesConfig.components.socialmedia,
    },
    socialmediaFooter: {
      ...defaultCreativesConfig.components.socialmediaFooter,
    },
    stickyCTA: {
      ...defaultCreativesConfig.components.stickyCTA,
    },
    stickyImage: {
      ...defaultCreativesConfig.components.stickyImage,
    },
    stickyText: {
      ...defaultCreativesConfig.components.stickyText,
    },
    store: {
      ...defaultCreativesConfig.components.store,
    },
    storeMenu: {
      ...defaultCreativesConfig.components.storeMenu,
    },
    terms: {
      ...defaultCreativesConfig.components.terms,
    },
    text: {
      ...defaultCreativesConfig.components.text,
    },
    hover: {
      ...defaultCreativesConfig.components.hover,
    },
    vastVideoXL: {
      ...defaultCreativesConfig.components.vastVideoXL,
    },
    viewLater: {
      ...defaultCreativesConfig.components.viewLater,
    },
    video: {
      ...defaultCreativesConfig.components.video,
    },
    programmaticHpa: {
      ...defaultCreativesConfig.components.programmaticHpa,
    },
    textButton: {
      ...defaultCreativesConfig.components.textButton,
    },
  },
};
